import { createTransform } from "redux-persist";

type FirebasePersistSlice = {
  auth?: unknown;
  data?: { global?: { config?: unknown }; [key: string]: unknown };
  listeners?: unknown;
  ordered?: unknown;
  requested?: unknown;
  profile?: unknown;
  isInitializing?: boolean;
  authError?: unknown;
  timestamps?: unknown;
};

export default createTransform(
  (inboundState: FirebasePersistSlice) => {
    if (!inboundState) {
      return inboundState;
    }
    const data: FirebasePersistSlice["data"] = {};
    if (inboundState.data?.global?.config) {
      data.global = { config: inboundState.data.global.config };
    }
    return { data };
  },
  (outboundState: FirebasePersistSlice) => {
    if (!outboundState) {
      return outboundState;
    }
    const data: FirebasePersistSlice["data"] = {};
    if (outboundState.data?.global?.config) {
      data.global = { config: outboundState.data.global.config };
    }
    return {
      auth: { isLoaded: false, isEmpty: true },
      authError: null,
      data,
      ordered: {},
      profile: {},
      listeners: {},
      requested: {},
      timestamps: {},
      isInitializing: false,
    };
  },
  { whitelist: ["firebase"] }
);
